import { LanguageFileType } from "types/Common";

const da_dk: LanguageFileType = {
  code: "dk",

  AboutMain:
    "Hos EasyPartz har vi besluttet os for at modernisere spåntagende bearbejdning og måden du bestiller CNC fræste emner på. Gennem automation og digitale værktøjer, hjælper vi dig med nemt og hurtigt at gå fra idé til fysisk produkt.",
  AboutSub:
    "Vi arbejder hele tiden på at udvide vores sortiment og kapacitet, så har du nogen specielle forespørgelser så kontakt os endelig.",
  AboutTitel: "Om easypartz",
  AboutUs: "Om Os",
  AddComponent: "Tilføj  komponent",
  AddToBasket: "Føj til kurv",
  AgreeButton: "Accepter",
  Aluminium5058: "Aluminium 5083",
  Aluminium5083Desc:
    "5083 aluminiumlegering er en aluminiumslegering med magnesium og spor af mangan og krom. Det er meget modstandsdygtigt over for angreb fra havvand og industrielle kemikalier.",
  Aluminium6082: "Aluminium 6082",
  Aluminium6082Desc:
    "Aluminiumslegering 6082 er en mellemstærk legering med fremragende korrosionsbestandighed. Den har den højeste styrke af legeringer i 6000-serien. Legering 6082 er kendt som en strukturlegering.",
  Aluminium7075: "Aluminium 7075",
  AluminiumTitel: "ALUMINIUM",
  Amount: "Antal",
  AnErrorOccurredCantUpdate:
    "Der skete en fejl, så produktet ikke kunne opdateres. Tjek din internetforbindelse og prøv igen senere.",
  Basket: "Indkøbskurv",
  Checkout: "Kassen",
  BasketEmpty: "Din kurv er tom",
  BasketCardHeader: "Kurv",
  BeadBlast: "Glasblæsning",
  Brass58: "Messing 58",
  ButtonBack: "Tilbage",
  ButtonOk: "Okay",
  CancelButton: "Annuller",
  Cases: "Cases",
  CasesMain:
    "Læs mere om hvordan EasyPartz hjælper forskings-, udviklings-, og produktionsafdelinger med at komme hurtigt videre.",
  ChangeBlueprint: "TRYK FOR AT UDSKIFTE ARBEJDSTEGNINGEN",
  CheckoutBasketEmpty: "Din kurv er tom...",
  CityInput: "By",

  // Component Configuration
  AddComment: "Tilføj note",
  Comment: "Komentar",
  AddNewCompButton: "Tilføj ny komponent",
  CompConfigAddedingToBasket: "Tilføjer konfigurationen til kurven...",

  CompConfigBlueprintButton: "Arbejdstegning",
  CompConfigCompAddedToBasket:
    "Din konfigurering blev tilføjet til din indkøbskurv!",
  CompConfigConfidentiality: "Alle filer behandles sikkert og fortroligt",
  CompConfigMaterialButton: "Materiale",
  CompConfigReturningToBasket: "Vender tilbage til kurven...",
  CompConfigSlowLoadMsg:
    "Beregningerne for din model er fortsat igang, men tager længere tid end normalt...",
  CompConfigSucces: "Succes",

  CompConfigUpadateingComp: "Opdaterer din konfiguration...",
  CompConfigUpdated: "Din konfiguration blev opdateret!",
  CompConfigUpdatedGoToBasketButton: "GÅ TIL KURV",
  Delete: "Slet",
  Edit: "Se & Rediger",
  ThreeDModelButton: "3d-model",
  CompanyName: "FirmaNavn",
  // Configurator Summary Card
  ConfiguratorPriceEachPiece: "pr. stk.",
  ConfSummaryPriceTotal: "Pris (eksl. moms)",
  ConfSummaryDays: " dage",
  ConfiguratorPriceFinishToolTip:
    "Prisen for den ekstra finish dine tilvalg kræver",
  ConfiguratorPriceHandelingToolTip:
    "Standardgebyr for håndtering af din bestilling",
  ConfiguratorPriceHandling: "Håndtering",
  Material: "Materiale",
  ConfiguratorPriceMaterialToolTip:
    "Prisen for materialeforbruget til at fremstille dit komponent",
  ConfiguratorPriceProduction: "Produktion",
  ConfiguratorPriceProductionToolTip:
    "Prisen for den tid, det tager at fremstille dit komponent",
  ConfiguratorPriceSetup: "Opsætning",
  ConfiguratorPriceSetupToolTip:
    "Prisen for at klargøre CAM-filen til opsætning af vores CNC-maskine",
  ConfSummaryModel: "Model",
  ConfSummaryConfiguration: "Konfiguration",
  ConfSummaryQuantity: "Styktal",
  ConfSummaryDelivery: "Produktionstid",
  ConfLeadTimeSubText: "Gælder for hele ordren",
  ConfSummaryPrice: "Pris",
  ConfiguratorPriceErrorMsg: "Mulige Udfordringer",
  ConfiguratorPriceCanNotGuarantee:
    "Bestillingen gennemgås manuelt for at sikre at den kan fremstilles. Vi kontakter dig hvis der er udfordringer.",
  ConfiguratorPriceCanNotGuarantee2:
    "Kontakt os gerne på telefon +45 60858075 eller email info@easypartz.com hvis du har spørgsmål.",
  ConfiguratorPriceSummaryFinishPomMsg: "IKKE MULIGT FOR POM",
  ConfiguratorPriceSummaryTitel: "OPSUMMERING",
  ConfiguratorPriceSummaryTitelSmall: "Opsummering",
  ConfirmOrderButton: "Afgiv bestilling",
  ConfirmPassword: "Bekræft Adgangskode",
  CookiePreferences: "Cookiepræferencer",
  CookiePreferencesChange: "Skift Cookie præferencer",
  CreateNewUserBody:
    "Opret en bruger og følg med i din ordrestatus, genbestil tidligere konfigurationer samt hurtig bestilling af nye komponenter.",
  CreateNewUserTitel: "Opret Ny Konto",
  CreateUserButton: "Opret Konto",
  CreatingUserMsg:
    "Vi opretter din bruger og flytter din gæstekurv over - Giv os etøjeblik...",
  CVRInput: "CVR-nummer",
  Dashboard: "Dashboard",
  DashboardNavBarToolTipClose: "LUK SIDEMENU",
  DashboardNavBarToolTipOpen: "ÅBEN SIDEMENU",
  Delivery: "Fragt",
  DeliveryMethod: "LEVERINGSMETODE",
  DeliveryMethodLower: "Leveringsmetode",
  DesignGuide: "DESIGN GUIDE",
  DemoButton: "3D Demo",
  DemoModeText: "Demo vist",

  // DFM Error Descriptions
  DFMErrorsFound: "Design Udfordringer",
  DFMErrorMultipleSolidsTitle: "Flere Emner",
  DFMErrorMultipleSolidsDesc:
    "Der blev detekteret flere individuelle emner i filen. Vores beregner kan desværre kun håndtere 1 emne ad gangen. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",
  DFMErrorNoSolidsTitle: "Ingen Emner",
  DFMErrorNoSolidsDesc:
    "Der blev ikke detekteret nogen emner i filen. Dette kan skyldes at modellen kun består af overflader. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",
  DFMErrorOverdimensionTitle: "Dimensioner",
  DFMErrorOverdimensionDesc1:
    "Modellen er større end vores garanterede maksimums dimensioner på 600mm x 500mm x 80mm. Modellen kan dog muligvis stadig fremstilles.",
  DFMErrorOverdimensionDesc2:
    "Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har behov for emner størrere end dette.",
  DFMErrorUnderdimensionTitle: "Dimensioner",
  DFMErrorUnderdimensionDesc1:
    "Modellen er mindre end vores garanterede minimums dimensioner på 8mm x 8mm x 2mm. Modellen kan dog muligvis stadig fremstilles.",
  DFMErrorUnderdimensionDesc2:
    "Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har behov for emner mindre end dette.",
  DFMErrorEdgeTitle: "Kanter",
  DFMErrorEdgeDesc:
    "Der blev detekteret kanter som kan være svære at fremstille. Invendige kanter bør afrundes med mindst 1mm radius. Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",
  DFMErrorFaceTitle: "Flader",
  DFMErrorFaceDesc:
    "Der blev detekteret flader som kan være svære at fremstille. Fladerne kan muligvis fremstilles ved brug af 5-akset bearbejdning eller special værktøjer. Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",
  DFMErrorPointTitle: "Punkter",
  DFMErrorPointDesc:
    "Der blev detekteret punkter som kan være svære at fremstille. Invendige punkter bør afrundes med mindst 1mm radius. Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",
  DFMErrorThinPlaneTitle: "Tynde Vægge",
  DFMErrorThinPlaneDesc:
    "Der blev detekteret overflader med tynde vægge (<0.9mm) som kan være svære at fremstille. Flader bør være mindst 1mm tykke for at sikre stabilitet. Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",
  DFMErrorDeepTitle: "Dybe Lommer",
  DFMErrorDeepDesc:
    "Der blev detekteret dybe lommer som kan være svære at fremstille. Lommer børe ikke være dybere end 5x bredden. Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",
  DFMErrorClearanceTitle: "Små Afstande",
  DFMErrorClearanceDesc:
    "Der blev detekteret overflader med lav afstand til hinanden (<1.9mm) som kan være svære at fremstille. Flader bør have mindste 2mm i afstande for ikke at kræve special værtktøjer. Ved bestilling vil modellen bliver gennemgået manuelt. Kontakt os evt. på telefon eller mail hvis du har spørgsmål.",

  DisagreeButton: "Afvis",
  DiscountCode: "Rabatkode",
  Discount: "Rabat",
  Email: "Email",
  EmailFaktura: "Send kopi af faktura til:",
  EmptyBasket: "TØM KURV",
  Disabled: "Disabled",

  // Error messages
  ErrorOnUpload:
    "Din model kunne ikke bearbejdes. Tjek at modellen er korrekt. Løser problemet sig ikke kan du kontakte os på info@easypartz.com",
  Error: "FEJL",
  ErrorBasketCouldNotBeEmptyed:
    "Produktet kunne desværre ikke fjernes fra din kurv grundet fejl: ",
  ErrorBasketCouldNotBeFetched:
    "Din indkøbskurv kunne desværre ikke hentes grundet fejl: ",
  ErrorCalcDeliveryPrice: "Der skete en fejl under beregning af fragtprisen ",
  ErrorCantUpdate:
    "Der skete en fejl, så produktet ikke kunne opdateres. Tjek din internetforbindelse og prøv igen senere.",
  ErrorCheckInternetTryAgain:
    ". Tjek din internetforbindelse og prøv igen senere.",
  ErrorCouldNotAddCompBecause:
    "Produktet kunne desværre ikke tilføjes til din kurv grundet fejl: ",
  ErrorCreatingID: "Identifikationsnummer kunne ikke oprettes: ",
  ErrorDesc: "Oooops! Ser ud til du er faret vild.",
  ErrorFileToBig: "Der skete en fejl, så prisen ikke kunne beregnes.",
  ErrorFinishingOrder: "Der skete en fejl under afslutning af din ordre ",
  ErrorGettingUser:
    "Der skete en fejl under indhentning af dine brugeroplysninger ",
  ErrorGuestBasketCouldNotBeTransferd:
    "Din gæstekurv kunne desværre ikke overføres til din nye bruger - ",
  ErrorMsg: "Der skete en fejl...",
  ErrorOccurred: "Der skete en fejl: ",
  ErrorSettingUpAddress: "Der skete en fejl under opsætningen af din adresse ",
  ErrorSub: "Side ikke fundet :(",
  ErrorUpdatingUser:
    "Der skete en fejl under opdatering af dine brugeroplysninger ",
  ExcludingMoms: "Ekskl. Moms",
  ExpiredSessionLogIn: "Din session er udløbet - du skal logge ind igen...",
  Filename: "Filnavn",
  Finish: "Finish",
  Anodizing: "Anodisering",
  FinishSelectionAnodizeDesc:
    "Materialet anodiseres, så det er bedre beskyttet mod korrosion",
  FinishSelectionBeadBlastDesc:
    "Materialet glasblæses, så det får en flot og mat finish",
  NoFinish: "Ingen finish",
  NoFinishDesc: "Materialet behandles ikke yderligere",
  FinishSelectionPOMErr:
    "Det er ikke muligt at tilvælge ekstra finish af POM plastik",
  FinishStandard: "STANDARD",
  FirmNameInput: "Firmannavn",
  FirstName: "Fornavn",
  ForgottenPassword: "Har du glemt din adgangskode?",
  ForgottenPasswordMsg:
    "Indtast din email og vi sender dig en mail med mulighed for at nulstille dit password, hvis kontoen findes i vores system.",
  FrontPage: "Forside",
  FrontPageMainText:
    "Nem online bestilling af CNC fræste emner i høj kvalitet - øjeblikkelig prisberegning og få dages leveringstid.",
  FrontPageSubText: " Prøv nu og modtag en pris med det samme!",
  FrontPageTitel: "DIT ONLINE MASKINVÆRKSTED",
  HelpBody:
    "Hvis du er i tvivl om, hvilke parametre der er vigtige for, at dine komponenter produceres til størst mulige tilfredsstillelse, er du kommet til rette sted. Vi har samlet de mest almindelige spørgsmål, som forhåbentlig kan besvare dine problemstillinger.",
  HelpBody2_1:
    "Skulle du fortsat brænde inde med spørgsmål eller er usikker på om dine komponenter kan fremstilles, er du velkommen til at skrive til os på",
  HelpBody2_2: " eller ringe på ",
  HelpCancelBody: "v1.0.0",
  HelpCancelTitel: "Hvordan annulerer jeg en bestilling?",
  HelpPaymentBody: "v1.0.0",
  HelpPaymentTitel: "Hvordan betaler jeg?",
  HelpPriceBody:
    "Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor.",
  HelpPriceTitel: "Hvorfor kan I ikke give mig en pris på min konfiguration?",
  HelpThreadBody: "v1.0.0",
  HelpThreadTitel: "Hvordan tilvælger jeg gevind?",
  HelpTitel: "Hjælp",
  HelpUploadBody:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis.",
  HelpUploadTitel: "Hvilke filtyper kan jeg uploade?",
  IAcceptEasy: "Jeg accepterer EasyPartz's ",
  IJoinNews: "Jeg vil gerne tilmeldes EasyPartz's nyhedsbrev ",
  InvoiceInfoBillingAddress: "Faktureringsadresse",
  InvoiceInfoCheckboxText: "Send varene til anden adresse?",
  InvoiceInfoDeliveryAddress: "Leveringsadresse",
  InvoiceInfoTitel: "FAKTURERINGSOPLYSNINGER",
  LastName: "Efternavn",
  ResetPassword: "Nulstil kodeord",
  RememberMe: "Husk mig",
  Login: "Login",
  LoginWrongCredentials: "Forket email eller adgangskode.",
  LoginMissingInfo: "Indtast venligst både din email samt kodeord.",
  LoginButton: "LOG IND",
  LoginForgetGuestBasket: "GLEM MIN GÆSTEKURV",
  LoginGuestBasketTrue: "Du har komponenter i din gæstekurv!",
  LoginGuestBasketTrueBody:
    "Vil du have indholdet af din gæstekurv overført til din egen kurv?",
  LoginInfoMissing: "Du mangler at indtaste dine loginoplysninger!",
  LoginTransferGuestBasket: "OVERFØR MIN GÆSTEKURV",
  LoginWaitMsg: "Logger dig ind... vent venligst",
  LogIn: "LOG IND",
  LogOut: "LOG UD",
  LogoutBody: "ER DU SIKKER PÅ, AT DU VIL LOGGE UD?",
  MaterialCardDeliveryHigh1: "Leveringstid påvirkes med ",
  Days: "dage",
  MaterialCardDeliveryLow: "Leveringstid påvirkes ikke.",
  MaterialCardDeliveryMed: "Leveringstid påvirkes med +1 dag.",
  MaterialCardInStock: "Vare på lager.",
  MaterialCardNotInStock: "Ikke på lager.",
  MaterialCardStatus1: "På lager",
  MaterialCardStatus2: "1 dag",
  Milimeter: "mm",
  MissingConfirmPassword: "Du har ikke bekræftet din adgangskode",
  ConfirmPasswordDifferent: "Dine adgangskoder er ikke ens",
  InvalidPasswordToken:
    "Din token er udløbet. Bed venligst om en ny email igen.",
  PasswordChangedSuccess: "Din adgangskode er ændret.",
  PasswordChangedError:
    "Din adgangskode kunne ikke ændres. Prøv venligst igen.",
  MissingEmail: 'Mangler "Email"',
  MissingFirstName: 'Mangler "Fornavn"',
  MissingLastName: 'Mangler "Efternavn"',
  MissingPassword: "Minimum 8 tegn med 1 stort bogstav!",
  MissingCVR: "Missing CVR number",
  MissingCompany: "Missing Company name",
  MissingRoad: "Missing Road",
  MissingZip: "Missing Zip code",
  MissingCity: "Missing City",
  MissingFakturaEmail: "Missing Faktura Email",
  MomsExcluded: "Eksl. moms",
  MomsIncluded: "TOTAL INKL. MOMS",
  MomsIncludedSmall: "inkl. moms",
  MyProfile: "MIN PROFIL",
  MyProfileSmaller: "Min Profil",
  MyProfileCompanyInfo: "Virksomhedsoplysninger:",
  MyProfileContactInformation: "Kontaktoplysninger:",
  MyProfileContactPerson: "Kontaktperson:",
  CVR: "CVR",
  MyProfileNoStandardAddress: "Ingen standardadresse",
  MyProfileNotSpecified: "Ikke angivet",
  MyProfilePhone: "Tlf.: ",
  MyProfileText:
    "Her har du mulighed for at ændre din standardadresse, så tilføjes den automatisk som leveringsadresse inden betaling:",
  MyProfileUpdateButton: "OPDATER BRUGEROPLYSNINGER",
  MyProfileCheckbox: "Gem en anden addresse til levering?",
  MyProfileBaseInfo: "Brugerinformation",
  NeedHelp: "BRUG FOR HJÆLP?",
  NewComponent: "Ny komponent",
  Configurator: "Konfigurator",
  ConfiguratorCNC: "CNC",
  ConfiguratorPrint3D: "3D print",
  NextButton: "Næste",
  NoButton: "Nej",
  NotReady: "Not ready",
  OfferingCNC: "CNC",
  OfferingCNCText: "Professionel CNC-bearbejdning",
  Dimensions: "Dimensioner",
  OfferingDimensionsText: "600mm x 500mm x 80mm",
  OfferingMaterialTitel: "MATERIALER",
  OfferingOrderStatus: "Ordrestatus",
  OfferingOrderStatusText: "Holder dig hele tiden opdateret",
  OfferingPrecision: "Præcision",
  OfferingPrecisionText: "ISO 2768(f) - ned til 0,02mm",
  OfferingPriceCalc: "Prisberegner",
  OfferingPriceCalcText: "Øjeblikkelig pris og feedback",
  OfferingProductionTime: "Produktionstid",
  OfferingProductionTimeText: "Ned til 3 dage",
  OfferingService: "SERVICE",
  OfferingTechnology: "TEKNOLOGI",
  OrderComment: "Ordre note",

  OrderDetails: "Ordredetaljer for",
  OrderDetailsDialogAddedToBasket: "Tilføjet til kurv",
  OrderDetailsDialogAddedToBasketBody:
    "De ønskede varer blev tilføjet til din kurv",
  OrderDetailsDialogAddingToBasket: "Tilføjer dine varer til kurven...",
  OrderDetailsDialogAddX1: "TILFØJ ",
  OrderDetailsDialogAddX2: " VARER TIL KURVEN",
  OrderDetailsDialogPayNowBtn: "Betal",
  OrderDetailsDialogAcceptQuoteBtn: "Godkend",
  OrderDetailsDialogErr: "Der skete en fejl: ",
  OrderDetailsDialogErrInternet:
    ". Tjek din internetforbindelse og prøv igen senere.",
  OrderDetailsDialogMark: "MARKÉR DE VARER DU ØNSKER AT GENBESTILLE",
  OrderDetailsMatFin: "Materiale / Finish",
  OrderDetailsTitel: "ORDREDETALJER",
  OrderDetailsTitelLower: "Ordredetaljer",
  OrderHistory: "ORDREHISTORIK",
  OrderHistorySmall: "Ordre Historik",
  OrderHistoryCheckSpamMsg:
    "Tjek din indbakke - den kan være havnet i din 'SPAM' -mappe.",
  OrderHistoryDate: "DATO",
  OrderHistoryOrderNumber: "ORDRENUMMER",
  OrderHistoryReceiver: "MODTAGER",
  OrderHistoryResend: "GENSEND FAKTURA",
  OrderHistoryResendt: "Din faktura blev gensendt",
  OrderHistoryResendtError:
    "Fakturaen blev ikke gensendt korrekt - tjek din internetforbindelse og prøv igen...",
  OrderHistoryStatus: "STATUS",
  OrderStatusPending: "Behandles",
  OrderStatusProcessing: "Godkendt",
  OrderStatusComplete: "Afsluttet",
  OrderStatusCancelled: "Annulleret",
  OrderStatusUnpaid: "Betaling mangler",
  OrderStatusQuote: "Tilbud",
  Outer: "Ydre",
  PANylon: "PA-NYLON",
  Password: "Adgangskode",
  PaymentMethod: "BETALINGSMETODE",
  PaymentMethodLower: "Betalingsmetode",
  PaymentBankTransfer: "Bankoverførsel / Faktura",
  PaymentBankTransferSubTitle: "14 dages betalingsfrist efter afsendelse",
  PaymentCardTransfer: "Kortbetaling",
  PaymentEAN: "EAN betaling",
  PaymentEANSubtitle: "Betal via GLN(EAN) nummer",
  PaymentOffer: "Tilbud på mail",
  PaymentOfferSubtitle: "Ordren sættes i gang når tilbuddet er godkendt",
  PaymentDeliveryNotice:
    "*Bemærk at leveringstid er ekskl. vores produktionstid!",
  PaymentMissingUser: "Du mangler at oprette en konto",
  PaymentNoUserBody:
    "Ønsker du at afgive en bestilling og få fuld adgang til vores smarte 'Mit Dashboard', skal du blot indtaste en adgangskode herunder:",
  PaymentOrderConfirmed:
    "Din ordre er modtaget - du vil inden for få minutter modtage en ordrebekræftelse fra os",
  PaymentThanks: "Tak for din bestilling!",
  PaymentFailed:
    "Betalingen gik ikke igennem. Prøv igen fra din ordrehistorik eller kontakt os for hjælp.",
  PdfSubtitle:
    "Tilføj en arbejdstegning for at angive yderligere specifikationer.",
  PdfExpense: "Et gebyr på 50 kr. vil blive pålagt din pris.",
  PEEKNatural: "PEEK-NATURAL",
  PhoneInput: "Telefonnummer",
  PiecePrice: "STK. PRIS",
  PlasticTitel: "PLASTIK",
  PleaseWait: "Vent venligst...",
  POMBlack: "SORT POM-C",
  POMBlackDesc:
    "Sort POM-C er et stift, hårdt og fjedrende materiale, som er velegnet til spåntagende bearbejdning. Det er kortspånet, og der kan opnås høj overfladefinish.",
  POMWhite: "HVID POM-C",
  POMWhiteDesc:
    "Hvid POM-C er et stift, hårdt og fjedrende materiale, som er velegnet til spåntagende bearbejdning. Det er kortspånet, og der kan opnås høj overfladefinish.",
  PostNordDelivery: "PostNord Erhverv",
  PostNordDeliveryText: "Vi sender med PostNord Erhverv til jeres adresse.",
  PostNordDeliveryTime: "1-2 hverdage",
  Price: "Pris",
  PriceAfter: "PRIS EFTER",
  PriceBefore: "PRIS FØR",
  ProductName: "Emne",
  ProductComment: "Note",
  PTFEWhite: "PTFE-WHITE",
  Reconfigure: "GENKONFIGURERING",
  RoadInput: "Vej",
  RoadNumberInput: "Nummer",
  SelfCollect: "Afhent hos EasyPartz",
  SelfCollectText: "Afhent på vores adresse: Maskinvej 5, 2860 Søborg.",
  SelfCollectTime: "Vi kontakter dig, så snart ordren er færdig",
  SendLinkButton: "SEND LINK",
  ShippingCardTime: "Leveringstid*: ",
  Shipping: "Shipping",
  SidebarEmptyBasket: "TOM KURV",
  SidebarOnlyForUsersText: "KUN TILGÆNGELIG FOR BRUGERE",
  SoftMetal: "BLØDE METALLER",
  SomethingWentWrong: "Der gik noget galt",
  SomethingWentWrongBody:
    "Noget gik galt under bestillingen af din ordre. Prøv igen fra din ordrehistorikeller kontakt os, så hjælper vi gerne",
  SpecialOfferBody1: "Med denne kurv kan vi måske give dig et bedre tilbud.",
  SpecialOfferBody2: "Hvis du vil høre mere kan du kontakte os: ",
  SpecialOfferTitel: "Special tilbud",
  StdErrorMsg:
    "  - Vi har fået besked om fejlen, og vil forsøge at rette den. Prøv evt. at 'refreshe' siden",
  Subtotal: "Subtotal",
  SupportsStepFiles:
    "Fil typer: STEP, STP File størrelse: < 12 MB Fil antal: < 10 Part størrelse: < 3000*3000*3000 mm",
  SupportsStepFilesNew:
    "Fil typer: STEP, STP.  |  Max. størrelse: 12 MB.  |   Max. antal:  10   |   Max. størrelse:  3000*3000*3000 mm",
  PrivacyPolicy: "Privatlivspolitik",
  TermsAndConditions: "Forretningsbetingelser:",
  TermsAndConditionsSub1: "Anvendelsesområde",
  TermsAndConditionsSub10: "Garanti",
  TermsAndConditionsSub11: "Ansvarsbegrænsning",
  TermsAndConditionsSub12: "Produktansvar",
  TermsAndConditionsSub13: "Værneting og lovvalg",
  TermsAndConditionsSub14: "Fravigelse",
  TermsAndConditionsSub2: "Tilbud",
  TermsAndConditionsSub3: "Priser",
  TermsAndConditionsSub4: "Betalingsbetingelser",
  TermsAndConditionsSub5: "Ejendomsforbehold",
  TermsAndConditionsSub6: "Levering",
  TermsAndConditionsSub7: "3D filer og arbejdstegninger",
  TermsAndConditionsSub8: "Reklamation",
  TermsAndConditionsSub9: "Returnering",
  TermsAndConditionsSubText1:
    "Nedennævnte salgs- og leveringsbetingelser er gældende for alle tilbud, salg og leverancer fra EasyPartz ApS (herefter kaldet ”sælger”), som driver EasyPartz.com, medmindre andet skriftligt er aftalt.",
  TermsAndConditionsSubText10:
    "Sælger yder ikke garanti medmindre andet skriftligt er aftalt.",
  TermsAndConditionsSubText11:
    "Sælger fraskriver sig i videst muligt omfang sig ansvar for ethvert tab og enhver skade, som køber eller andre måtte lide, det være sig direkte eller indirekte, som følge af brugen af det leverede produkt. I det omfang sælger måtte være ansvarlig overfor køber eller andre, er dette ansvar begrænset til det direkte tab, og sælger er således ikke ansvarlig for omsætningstab, driftstab, tidstab, avancetab eller lignende indirekte tab, herunder som følge af forsinkelse med levering eller mangler ved salgsgenstanden. Et eventuelt erstatningskrav overfor sælger kan ikke overstige fakturabeløbet incl. moms for den solgte genstand. Sælger kan ikke drages til ansvar for manglende opfyldelse af sine forpligtelser, såfremt de forhindres af eller gøres urimeligt byrdefulde som følge af brand, eksplosion, naturkatastrofer, krig, uroligheder, undtagelsestilstande, beslaglæggelse, valutarestriktioner, import/eksportforbud, arbejdskonflikt og mangel på transport, generel materialemangel ved eller forsinkelse af leverance fra underleverandører eller andre omstændigheder udenfor sælgers herredømme.",
  TermsAndConditionsSubText12:
    "I det omfang intet andet følger af ufravigelige lovbestemmelse gælder følgende vedrørende sælgers produktansvar: Sælger er ikke ansvarlig for formuetab som ikke er en følge af en af sælgers erstatningsansvar omfattet person- eller tingskade. Sælger er ikke ansvarlig for skade på fast ejendom eller løsøre, ligesom sælger ikke er ansvarlig for driftstab, avancetab eller andre indirekte tab eller skader. Sælger er alene ansvarlig for personskade forvoldt af de leverede produkter, såfremt det kan dokumenteres, at den opståede skade skyldes fejl og forsømmelser udvist af sælger.",
  TermsAndConditionsSubText13:
    "Eventuelle tvister vedrørende aftaler mellem køber og sælger skal afgøres ved Københavns Byret. Dansk ret finder anvendelse.",
  TermsAndConditionsSubText14:
    "Nærværende salgs- og leveringsbetingelser kan alene fraviges ved skriftlig aftale parterne imellem.",
  TermsAndConditionsSubText2:
    "Skriftlige tilbud fra sælger er alene bindende for sælger, såfremt de skriftligt accepteres inden 30 dage fra tilbuddets datering. I modsat fald anses tilbuddet for bortfaldet. Mundtlige tilbud er ikke bindende for sælger, medmindre sælger fremsender skriftlig ordrebekræftelse til køber. De i ordrebekræftelsen angivne vilkår er herefter gældende. For specialfremstillede varer forbeholder sælger sig at ændre tilbuddet i enhver henseende, indtil sælgers endelige godkendelse af købers udkast eller originalmateriale foreligger.",
  TermsAndConditionsSubText3:
    "Alle anførte priser er i danske kroner og excl. moms og eventuelle andre omsætningsafgifter. Ved ordre af større eller mindre mængder end angivet i tilbuddet, forbeholder sælger sig at ændre pris og leveringstidspunkt. Køber er forpligtet til indtil levering at acceptere ændringer i prisen, som følge af ændringer i prisen fra sælgers leverandør som følge af dokumenterede forøgede omkostninger for sælger, så som ændringer i told, skatter, afgifter m.v., som følge af øgede omkostninger for sælger, så som prisstigninger på råvarer, ændringer i told, skatter og afgifter m.v. Såfremt sælgers omkostninger forøges som følge af købers forhold, kan sælger kræve godtgørelse herfor. Rabatter ydes alene, hvis det er skriftligt aftalt.",
  TermsAndConditionsSubText4:
    "Betalingsbetingelserne er netto kontant ved købers modtagelse af varen, medmindre andet skriftligt er aftalt i ordrebekræftigelsen eller faktura. Betaler køberen ikke til aftalt tid, beregnes en morarente på 2% pr. påbegyndt måned. Aftalte rabatter ydes kun, såfremt betalingen indgår rettidigt. Hvis levering udskydes på grund af købers forhold (fordringshavermora) er køber forpligtet til at foretage enhver betaling til sælger, som om levering var sket til aftalt tid. Opstår der usikkerhed om købers betalingsevne, herunder som følge af restance overfor sælger, er sælger berettiget til at kræve forudbetaling eller sikkerhedsstillelse for betaling af såvel allerede forfaldent tilgodehavende, som for fremtidige forfaldne beløb. Ved købers misligholdelse er sælger berettiget til at annullere tidligere givne tilsagn om betalingsfrister af enhver art. Modregning for så vidt angår ikke forfaldne eller bestridte krav kan alene foretages af køber, såfremt sælger skriftligt har givet sin accept hertil.",
  TermsAndConditionsSubText5:
    "Det leverede forbliver sælgers ejendom indtil hele købesummen incl. fragt, gebyr m.v. er betalt. Køber er ikke berettiget til at modregne eventuelle modkrav.",
  TermsAndConditionsSubText6:
    "Levering sker fra sælgers forretningsadresse, uanset om sælger ved egne folk eller ved tredjemand i henhold til særskilt aftale med køber bringer salgsgenstanden frem til køber. I så fald betaler køber fragt fra leveringssteddet samt et ekspeditionsgebyr. Leveringstid er angivet af sælger efter bedste skøn i overensstemmelse med de forhold, der foreligger ved tilbuddets fremsættelse/aftalens indgåelse. Ved ændrede forudsætninger er sælger berettiget til at udskyde leveringen, men må uden ugrundet ophold meddele køber den ændrede leveringstid. Hvis forsinkelse ved levering skyldes, at sælger er inde i en situation som angivet i afsnittet om ansvarsbegrænsning, udskydes leveringstiden med den tid, som hindringen varer. Begge parter er dog berettiget til ansvarsfrit at annullere aftalen, når hindringen har varet i mere end 2 måneder. Har leveringen ikke fundet sted senest 2 måneder efter det opgivne leveringstidspunkt, er køber berettiget til ved skriftlig meddelelse til selskabet at tilkendegive, at ordren annulleres, såfremt levering ikke finder sted inden 14 dage efter, at selskabet har modtaget meddelelsen. Sker leveringen ikke inden udløbet af de 14 dage, betragtes ordren som annulleret.",
  TermsAndConditionsSubText7:
    "De af køber leverede 3D filer og relaterede arbejdstegninger, til brug for fremstilling af varer, behandles fortroligt og destrueres ved købers anmodning.",
  TermsAndConditionsSubText8:
    "Mangler opstået som følge af overlast, usædvanlig brug eller almindelig slid, omfattes ikke af sælgers ansvar. Ved levering er køber forpligtet til at undersøge varen straks ved modtagelsen. Reklamation må fremsættes skriftligt inden 8 dage fra modtagelsen. Såfremt køber har opdaget eller burde have opdaget mangler og ikke reklameret som anført, kan køber ikke senere gøre manglen gældende. Efter sælgers frie valg kan mangler ved salgsgenstanden afhjælpes eller sælger kan foretage omlevering. For købers mangelsbeføjelser henvises til dansk rets almindelige regler herom. Forandring og/eller indgreb i salgsgenstanden uden sælgers skriftlige samtykke fritager sælger for enhver forpligtelse.",
  TermsAndConditionsSubText9:
    "Salgsgenstande modtages som udgangspunkt aldrig retur. Såfremt salgsgenstanden ønskes returneret, kan dette alene ske efter forudgående skriftlig aftale. I fald der er indgået en forudgående skriftlig aftale om ret til at returnere salgsgenstande, skal retursendinger være i ubrudt original emballage med angivelse af den udstedte fakturas datering og nummer. Såfremt der måtte være aftalt ret til returnering forbeholder sælger sig ret til ved kreditering at fortage fradrag af et sælgers fastlagt gebyr for returneringen. Specialfremstillede eller specialfremskaffede varer tages aldrig retur.",
  TermsAndConditionsTitel: "SALGS- OG LEVERINGSBETINGELSER",
  TermsOfTrade: "Handelsbetingelser",

  // Configurator - Holes & Threads
  Thread: "HULLER/ GEVIND",
  ThreadCardThread: "Gevind",
  ThreadCardQuantity: "Antal",
  ThreadCardDiameter: "Diameter",
  ThreadCardDepth: "Dybde",
  ThreadCardDepthErrorMsg1:
    "Hullet er dybere end normalt for denne gevindtype. Vi skærer gevindet ",
  ThreadCardDepthErrorMsg2: "mm dybt.",
  ThreadCardMaxDepth: "Max. dybde: ",
  ThreadCardMixedThreads: "Blandet",
  ThreadCardNoThreads: "Ingen",
  ThreadCardSpecify: "Specificer Enkeltvis",
  LongDeliveryTime:
    "Vi arbejder på nedsat blus i sommer ugerne 26, 30, 31 og 32, hvor der må derfor forventes ekstra leveringstid.",
  ClosedChristmas: "Vi holder lukket mellem jul og nytår.",

  Total: "Total",
  UpdateConfig: "OPDATER KONFIGURATION",
  UpgradingGuestWaitingMsg:
    "Vi opretter din bruger og flytter din gæstekurv over - Giv os et øjeblik...",
  UploadBlueprint: "Upload Arbejdstegning",
  UploadThreeDModel:
    "Træk og slip dine 3D modeller eller klik for at vælge filer",
  UseCoupon: "Anvend",
  UserCreatedMsg: "Din bruger er nu oprettet! Du kan nu logge ind!",
  WaitingMsg: "Vi er ved at oprette din konto...",
  WarningChangesNotSaved:
    "Dine ændringer gemmes ikke, hvis du forlader konfiguratoren nu! BEMÆRK: Ændring af arbejdstegninger gemmes altid!",
  PONumber: "PO nummer",
  EANNumber: "GLN nummer (EAN)",
  WarningLoseConfig:
    "Du mister din konfiguration, hvis du forlader komponent konfiguratioren nu!",
  WeOffer: "Vi Tilbyder",
  YesButton: "Ja",
  ZipInput: "Postnummer",
  WeTransferedYourBasket:
    "Vi har overført din indkøbskurv til din bruger. Tjek og bekræft indkøbskurv.",
  AlreadyAUser: "Har du allderede en bruger? Log ind her.",
  AlreadyAUserBody:
    "Har du allederede en bruger men glemte at logge ind kan du gøre det her. Vi overfører denne guestekurv til din bruger og opdatere din session.",
  ForgotLogin: "Du mangler at logge ind!",
  ConfirmingOrder: "Bekræfter din ordre...",
  NowLoggedIn: "Du er nu logget ind!",
  Confirm: "Bekræft",

  OfferingPageMetaTitel: "CNC bearbejdningscenter tilbyder",
  OfferingPageMetaText:
    "CNC bearbejdningscenter EasyPartz tilbyder nem online bestilling af CNC fræste emner. Upload din 3D model, få straks en pris og levering efter få dage. Prøv det her!",
  OfferingPageH1: "CNC bearbejdningscenter",
  LoginPageMetaTitel: "Maskinværksted hos EasyPartz",
  LoginPageMetaText:
    "CNC fræsning aluminium, plastik og andre materialer i høj kvalitet. Opret dig som bruger, upload 3D model, få pris og bestil til levering efter få dage. Prøv det nu!",
  LoginPageH1: "CNC fræsning aluminium",
  AboutMetaTitel: "Spåntagende bearbejdning og CNC fræsning",
  AboutMetaText:
    "Spåntagende bearbejdning i høj kvalitet og med hurtig levering på EasyPartz online maskinværksted. Moderniseret og automatiseret bestilling af CNC fræste emner. ",
  AboutH1: "Spåntagende bearbejdning",
  CasesPageMetaTitel: "Fræsning aluminium hos EasyPartz maskinværksted",
  CasesPageMetaText:
    "Fræsning aluminium, plastik  og andre materialer med nem online bestilling. Øjeblikkelig prisberegning og levering på få dage. Bestil dine hasteemner billigt her!",
  CasesPageH1: "Fræsning aluminium",
  KeyWords:
    "CNC Bearbejdning, Online maskinværksted, EasyPartz, Spåntagende bearbejdning, Fræsning aluminium",
  TNT1Titel: "TNT Express før 09:00",
  TNT1Body:
    "Når din ordre er færdig produceret express forsender vi den med TNT til din adresse.",
  TNT1DeliveryTime: "Næste dag før 09:00",
  TNT2Titel: "TNT Express før 12:00",
  TNT2Body:
    "Når din ordre er færdig produceret express forsender vi den med TNT til din adresse.",
  TNT2DeliveryTime: "Næste dag før 12:00",
  TNT3Titel: "TNT Express næste dag",
  TNT3Body:
    "Når din ordre er færdig produceret express forsender vi den med TNT til din adresse.",
  TNT3DeliveryTime: "Næste dag",

  // Front Page Content
  FrontPageMetaTitel: "Maskinværksted",
  FrontPageMetaText:
    "CNC bearbejdning hos EasyPartz online maskinværksted. Upload din 3D model, få øjeblikkelig pris og levering efter kun få dage. Simpelt og hurtigt. Prøv det her!",
  FrontPageH1: "Maskinværksted – På den nemme måde",
  FrontPageH2: "Bestil CNC fræste komponenter på 2 minutter",
  FrontPageH3:
    "EasyPartz er et moderne maskinværksted, hvor du kan bestille CNC fræste komponenter nemt og hurtigt. Upload din 3D model, så beregnes prisen øjeblikkeligt, og du modtager typisk dine emner inden for 4-5 hverdage.",
  FrontPageH3Sub:
    "Du er også velkommen til at maile 3D modeller og arbejdstegninger til info@easypartz.com, så vender vi tilbage med et tilbud hurtigst muligt, typisk inden for få timer.",
  FrontPageTextOpen247Titel: "Åbent 24/7 hele året rundt!",
  FrontPageTextOpen247:
    "EasyPartz maskinværksted fungerer som en normal webshop. Du kan handle når det passer dig, og du undgår unødvendig email-korrespondance og lange svartider, så du kan komme hurtigt videre med værdiskabende opgaver. Har du specielle ønsker eller spørgsmål er du også velkommen til at kontakte os på chat, email info@easypartz.com eller telefon +45 60858075.",
  FrontPageTextServiceTitel: "Service og Support i Særklasse",
  FrontPageTextService:
    "Har du behov for teknisk sparring for at optimere dit design, vejledning i materialer og efterbearbejdning eller spørgsmål til vores service og online bereger? Så er du velkommen til at kontakte os på chat, email info@easypartz.com og telefon +45 60858075. Vores medarbejdere står klar til at vejlede og besvare alle dine spørgsmål.",
  FrontPageTextSatisfactionTitel: "100% Tilfredshedsgaranti",
  FrontPageTextSatisfaction:
    "EasyPartz tilbyder 100% tilfredshedsgaranti på alle bestillinger. Er du ikke er tilfreds med de leverede dele, kan du returnere dem og få fuld refundering af betalingen. Der er derfor kun gevinster ved at prøve EasyPartz maskinværksted som din nye leverandør af CNC bearbejdede emner.",
  FrontPageTextHowToTitel: "Hvordan gør jeg?",
  FrontPageTextHowTo:
    "Upload din 3D model i boksen ovenfor, så er du i gang! Vi godtager .stp/.step filer (og snart også .igs/.iges) som kan eksporteres i alle gængse 3D modellerings- og CAD programmer. Når modellen er uploadet, tager det kun få sekunder inden du har en pris. Du kan herefter vælge styktal, materiale, efterbehandling, gevind og tolerancer. Du behøver ikke engang lave arbejdstegninger!",
  FrontPageTextSparringTitel: "Feedback og sparring?",
  FrontPageTextSparring:
    "Når du uploader en model hos EasyPartz, så udføres der automatisk en DFM analyse, som identificerer og visualiserer de mest gængse design fejl. Bl.a. skarpe interne kanter, tynde vægge og utilgængelige flader. Du får derfor øjeblikkelig feedback så du kan optimere dit design. Har du spørgsmål eller behov for teknisk sparring, så er du også velkommen til at kontakte os på chat, email info@easypartz.com og telefon +45 60858075.",
  FrontPageTextSpeedTitel: "Hvor hurtigt leverer i?",
  FrontPageTextSpeed:
    "Hastighed er en af de vigtigste faktorer, når der skal fremstilles prototyper, maskindele, testopstillinger eller andre komponenter. Derfor har lagt bestillingsprocessen online, så du ikke skal bruge tid på langsommelig kommunikation. Vi bestræber os at fremstille din bestilling inden for 4 arbejdsdage, og sørger også for at både efterbearbejdning og shipping sker så hurtigt som muligt.",
  FrontPageTextPriceTitel: "Hvad koster det?",
  FrontPageTextPrice:
    "EasyPartz maskinværksted anvender originale maskiner, udstyr og software, som i højere grad automatiserer produktionen, selv ved enkeltstyk produktioner. Opsætning kan traditionelt udgøre størstedelen af produktionsudgifterne ved små og mellemstore serier, og vi kan derfor tilbyde hurtig levering til attraktive priser. Prøv selv at uploade en 3D model i boksen ovenfor, og få beregnet prisen på få sekunder. Ved størrere serier hjælper vi gerne med at optimere design og produktion så prisen bliver rigtig.",
  FrontPageTextTechonolgyTitel: "Hvordan kan det lade sig gøre? ",
  FrontPageTextTechonolgy:
    "Vi har hos EasyPartz udviklet originale maskiner, udstyr og software, som gør os i stand til at automatisere og simplificere produktionen af CNC fræste emner. Det er især de videnstunge manuelle processer i forbindelse med programmering (CAM), klargøring og opsætning, som vi fokuserer på at optimere. Processer som ellers ofte bliver nedprioriteret hos maskinværksteder der fokuserer mere på storskala produktion. Du kan lære mere om vores teknologier ved at følge os på Youtube, Facebook og LinkedIn.",
  FrontPageTextServicesTitel: "Hvad kan I fremstille?",
  FrontPageTextServices:
    "EasyPartz tilbyder professionel CNC fræsning. Vi er specialiseret i små og mellemstore serier, typisk fra 1 til 1000 emner, og ingen ordre er for lille. Den perfekte løsning til fremstilling af maskindele, specialudstyr, prototyper, reservedele, samt små og mellemstore serier. Vi har altid  POM og aluminium på lager, og kan hurtigt skaffe en lang række andre materialer hjem. Har vi ikke dit materiale eller behov på hjemmesiden, så kontakt os på chat, email eller telefon.",

  Case1: `"Vi plejede at vente dage på tilbud og uger på at dele kom frem. EasyPartz beregner øjeblikkeligt pris og leveringstid, og vi modtager komponenterne på få dage. Det er en stor fordel for os."`,
  Case2: `"Når vi designer nye produkter er det rart med en leverandør som EasyPartz, der er fleksible, leverer hurtigt, og hvor vi også kan få teknisk sparring i forhold til produktionsoptimering. Vi har anvendt EasyPartz til fremstilling af både prototyper og 0-serier, og de deler gladelig deres ekspertise inden for konstruktion og produktionsteknik, så vi får optimeret vores designs."`,
  Case3: `"Vi benytter Vaerks som underleverandør af fræsede plast- og aluminiumskomponenter, fordi det er fleksibelt, der er kort leveringstid og de leverer til tiden. Med EasyPartz har vi kunne skalere produktionen i takt med efterspørgslen på vores produkter, fra prototype til flere hundrede enheder. Det har været en stor fordel for os, bl.a. fordi vi har undgået tidlige investeringer i dyre sprøjtestøbningsforme."`,
  UploadSuccessMsg:
    "Filen blev tilføjet successfuldt. Vent venligt imens vi bearbejder den.",
  UploadFailedMsg:
    "Filen kunne kunne lægges op. Prøv igen senere eller kontakt os.",
  ComingSoon: "Kommer snart!",
  ChangeModel: "Skift model\xa0",
  StayDEMO: "Bliv ved demo",
  BasketSummaryFees: "Gebyrer",
  BasketSummaryLeadtimeHeader: "Produktionstid",
  BasketSummaryLeadTimeSubHeader: "Hverdage",
  BasketSummaryLeadtimeText: "dage",
  BasketExternalSupplier: "Ekstern Leverandør",
  BasketExternalSupplierTooltip:
    "Ordrer med lang leveringstid produceres af EasyPartz's partnere. Data videregives derfor til tredjeparter.",
  UserModalTitle: "Din EasyPartz Bruger",
  UserModalText:
    "For at kunne uploade dine egne modeller, skal du benytte en bruger. Dette tillader dig, at tilføje og konfigurere dine komponenter samt gennemføre en bestilling.",
  BeforeWeStart: "Før vi starter..",
  BeforeWeStartText:
    "Før vi starter skal du logge ind eller oprette en bruger. Derefter kan du uploade din model.",
  BeforeWeStartMoreBtn: "Hør mere om hvorfor?",
  BeforeWeStartTryDemo:
    "Hvis du vil se mulighederne inde du opretter en bruger så klik %s for at afprøve vores demo model.",
  here: "her",
  PleaseLoginText:
    "For at uploade en model skal du være logget ind. Hvis du ikke har en bruger kan du nemt oprette en, det tager kun 2 minutter.",
  LoginOrRegister: "LOGIN / OPRET BRUGER",
  fetchingPrice: "Opdaterer prisen...",

  OrderTitle: "Tusind tak for din ordre.",
  OrderSubtext:
    "Vi har modtaget din ordre og du vil inden længe modtage en ordrebekræftelse på din email. Hvis du har spørgsmål er du velkommen til at kontakte os på chat eller email.",
  details: "Detaljer",
  orderNumber: "Ordrenummer",
  date: "Dato",
  email: "Email",
  paymentMethod: "Betalingsmetode",
  deliveryMethod: "Leveringsmetode",
  invoiceAddress: "Faktureringsadresse",
  deliveryAddress: "Leveringsadresse",
  products: "Produkter",
  name: "Navn",
  material: "Materiale",
  quantity: "Antal",
  finish: "Finish",
  price: "Pris",
  unit: "stk",
};

export default da_dk;
